<template>
  <div>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card title="SUNDRY ITEM CATALOGUE LIST" >
          <template slot="actions">
            <vs-button icon-pack="feather" icon="icon-arrow-left" @click="refreshData" class="mr-4" color="primary" type="border">
              Back to orders
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table id="sundry-item-price-list"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="staff"
              sort
              :sst="true"
              class="table-dark-inverted table-auto vs-con-loading__container">
              <template slot="header">
                <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                          v-model="filters['search']"
                          class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
               <vs-button id="place_order"
                          @click.native="createOrder"
                          :disabled="cartItems.length === 0"
                          icon-pack="feather" icon="icon-shopping-cart"
                          class="mr-8"
                          color="primary"
                          type="filled">
                 View cart ({{cartItems.length}} Items)
               </vs-button>
                <!-- <sundry-item-cart-drop-down v-on:createOrder="createOrder" class="mr-8" v-on:refresh="onlyRefreshData" v-on:refreshData="refreshData" v-bind:cartItems="cartItems"/> -->
              </template>
              <template slot="thead">
                <vs-th>ITS ITEM CODE</vs-th>
                <vs-th>SUPPLIER PRODUCT CODE</vs-th>
                <vs-th>SUPPLIER PRODUCT NAME</vs-th>
                <vs-th>SUPPLIER</vs-th>
                <vs-th>MIN ORDER QTY</vs-th>
                <vs-th>CURRENCY</vs-th>
                <vs-th>UNIT PRICE</vs-th>
                <vs-th>ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr
                  v-if="!isOnCart(data[indextr].id)" @click.native="onClickAddRm(data[indextr])" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].sundry_item_code">
                    {{ data[indextr].sundry_item_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_product_code">
                    {{ data[indextr].sundry_product_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_product_name">
                    {{data[indextr].sundry_product_name}}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_supplier">
                      {{ data[indextr].sundry_supplier }}
                  </vs-td>

                  <vs-td :data="data[indextr].min_OQ">
                    {{ data[indextr].min_OQ }}
                  </vs-td>

                  <vs-td :data="data[indextr].sundry_supplier_currency">
                    {{ data[indextr].sundry_supplier_currency }}
                  </vs-td>

                  <vs-td :data="data[indextr].unit_price">
                    {{ data[indextr].unit_price }}
                  </vs-td>

                  <vs-td >
                    <div class="vx-row">
                      <vx-tooltip text="view / add" position="left">
                        <vs-button @click="onClickAddRm(data[indextr])"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-plus"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>

    <show-sundry-item-price-pop-up ref="showSundryItemPricePopUp"/>
    <create-rm-order-pop-up ref="createRmOrderPopUp"/>
    <create-sundry-item-order-pop-up v-on:refreshData="refreshData" ref="createSundryItemOrderPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  const SundrySupplierRepository = RepositoryFactory.get('sundry')
  import ShowSundryItemPricePopUp from '@/components/popups/sundry-suppliers/sundry-item-orders/ShowSundryItemPricePopUp'
  import CreateRmOrderPopUp from '@/components/popups/inventory/rm-orders/CreateRmOrderPopUp'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "../../../../constants/config";

  import SundryItemCartDropDown from "./SundryItemCartDropDown";
  import CreateSundryItemOrderPopUp from '@/components/popups/sundry-suppliers/sundry-item-orders/CreateSundryItemOrderPopUp'

  export default {
    name: 'AllUsersList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        perPage: defaultPagination,
        descriptionItems: perPageList,
        cartItems: []
      }
    },
    components: {
      'v-select': vSelect,
      ShowSundryItemPricePopUp,
      SundryItemCartDropDown,
      CreateRmOrderPopUp,
      CreateSundryItemOrderPopUp
    },
    mounted() {
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    methods: {
      async refreshData () {
        await this.$refs.createSundryItemOrderPopUp.onClose()
        this.$emit('back', '')
      },
      async onlyRefreshData() {
        await this.fetchProjectBrief()
      },
      async createOrder() {
        await this.$refs.createSundryItemOrderPopUp.openPopup()
      },
      async fetchProjectBrief() {
        await this.$vs.loading({
          container: '#sundry-item-price-list',
          scale: 0.45
        })
        await this.getRmOrderCart()
        const {data} = await SundrySupplierRepository.getSundryItemCatalogueList(this.page, this.filterQuery, this.perPage)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close('#sundry-item-price-list > .con-vs-loading')
      },
      async getRmOrderCart() {
        const {data} = await SundrySupplierRepository.getListOfSundryItemCart()
        this.cartItems = data.data
      },
      async onClickAddRm (data) {
        this.$refs.showSundryItemPricePopUp.openPopup(data)
      },
      
      filterQueryUpdate (){
        this.fetchProjectBrief()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchProjectBrief()
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      isOnCart: function (value) {
        return !!this.cartItems.find((n) => {
          return Number(n.sundry_item_id) === Number(value)
        })
      }
    },
    watch : {
      page(){
        this.fetchProjectBrief()
      },
      perPage() {
        this.fetchProjectBrief()
      }
    },
    computed: {

    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
